import size from "../sizes";
import image1 from "../../assets/images/materials/hoodie/1.jpg";
import image21 from "../../assets/images/materials/hoodie/2-1.jpg";
import image22 from "../../assets/images/materials/hoodie/2-2.jpg";
import image3 from "../../assets/images/materials/hoodie/3.jpg";
import image41 from "../../assets/images/materials/hoodie/4-1.jpg";
import image42 from "../../assets/images/materials/hoodie/4-2.jpg";
import image5 from "../../assets/images/materials/hoodie/5.jpg";
import image7 from "../../assets/images/materials/hoodie/7.jpg";
import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Удобная и универсальная толстовка с запечатыванием всей поверхности изделия. Большая размерная линейка, удобный крой и приятная ткань - придутся по вкусу всем. Запечатывается даже сквозной карман "кенгуру" и капюшон. Толстовка состоит из 100% микрофибры и нанесенный принт выдерживает неограниченное количество стирок.</p>`,
      images: [
        {
          source: image1,
          captionContent: {
            title: `Тепло и комфорт`,
            description: `Наши толстовки сделаны из дорогого 3х-ниточного футера. Такая ткань получается плотной благодаря плетению, но при этом дышит, потому что изготавливается из 100% хлопка наивысшего качества. Изнанка может быть с начёсом или петелька - уточняйте наличие у менеджера.`
          }
        },
        {
          source: image21,
          captionContent: {
            title: `Рукава с резинкой`,
            description: `Резинка на рукавах со временем не растягивается и приятно облегает запястье. Для более расслабленного образа подтяните рукава до локтей: резинка хорошо тянется и не передавливает руку.`
          }
        },
        {
          source: image22,
          captionContent: {
            title: `Рукава с резинкой`,
            description: `Резинка на рукавах со временем не растягивается и приятно облегает запястье. Для более расслабленного образа подтяните рукава до локтей: резинка хорошо тянется и не передавливает руку.`
          }
        },
        {
          source: image3,
          captionContent: {
            title: `Швы в цвет ткани`,
            description: `Внешние швы выполнены в цвет ткани. Они ровные и аккуратные, без торчащих ниток или спутанных узелков. Такая толстовка выглядит дорого и стильно.`
          }
        },
        {
          source: image41,
          captionContent: {
            title: `Яркий принт`,
            description: `Мы используем фирменные чернила и профессиональные принтеры для прямой печати на ткани (DTG), поэтому ваши дизайны выглядят яркими и со временем не выцветают. Качественная ткань не линяет даже после многочисленных стирок.`
          }
        },
        {
          source: image42,
          captionContent: {
            title: `Шелкография для больших тиражей`,
            description: `Для тиражей от 30 штук хорошо подходит шелкография: это метод, при котором краска наносится на ткань через трафарет. Такой способ нанесения хорошо перекрывает цвет ткани, и картинка получается яркой и насыщенной.`
          }
        },
        {
          source: image5,
          captionContent: {
            title: `Классический крой`,
            description: `Мы используем толстовки классического кроя, которые хорошо садятся как на мужчин, так и на женщин. Небольшой эффект оверсайз создает модный силуэт и выглядит стильно.`
          }
        },
        {
          source: image7,
          captionContent: {
            title: `Рукава с резинкой`,
            description: `На рукавах удобная резинка, благодаря которой рукава не задираются и хорошо сидят на запястьях. Резинка сшита из качественной рибаны, поэтому она не растягивается от регулярной носки.`
          }
        }
      ]
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`full_print_hoodie`],
      sizeInfo: `full_print_hoodie`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
